var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"r-tab-for-pc"},[_c('div',{staticClass:"r-tab-for-pc--label",class:{ 'r-tab-for-pc__active': _vm.isShow },on:{"click":_vm.clickHandler}},[_vm._v(" "+_vm._s(_vm.label)+" ")]),(_vm.isShow)?_c('div',{staticClass:"r-tab-for-pc--content"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }